// src/pages/home/index.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/Logo.png";
import "./home.css";

const RegisterIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M19 8v6M22 11h-6" />
  </svg>
);

const LoginIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
    <path d="M10 17l5-5-5-5M15 12H3" />
  </svg>
);

const ResetIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="11" width="14" height="10" rx="3" />
    <path d="M8 11V7a4 4 0 0 1 8 0v1" />
  </svg>
);



const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="exam-landing">
      <div className="exam-card">
        <div className="exam-card__header">
          <div className="clay-badge" aria-hidden="true">
            <img src={Logo} alt="AediaX" className="brand-logo" />
          </div>
          <h1>AediaX Examination Portal</h1>
          <p>A secure, scalable &amp; intelligent online examination system</p>
        </div>

        <div className="exam-card__actions">
          <button className="btn btn--primary" onClick={() => navigate("/auth/sign-up")}>
            <span className="btn__chip"><RegisterIcon /></span>
            Register for Exam
          </button>
          <button className="btn btn--secondary" onClick={() => navigate("/auth/sign-in")}>
            <span className="btn__chip"><LoginIcon /></span>
            Login to Exam
          </button>
          <button className="btn btn--text" onClick={() => navigate("/auth/reset-password")}>
            <span className="btn__chip btn__chip--flat"><ResetIcon /></span>
            Forgot / Reset Password
          </button>
        </div>

        <p className="exam-card__footer">© {new Date().getFullYear()} AediaX Examination Platform</p>
      </div>
    </div>
  );
};

export default Home;